import { render, staticRenderFns } from "./UploadImagePreview.vue?vue&type=template&id=07a87636&scoped=true&"
import script from "./UploadImagePreview.vue?vue&type=script&lang=js&"
export * from "./UploadImagePreview.vue?vue&type=script&lang=js&"
import style0 from "./UploadImagePreview.vue?vue&type=style&index=0&id=07a87636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a87636",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
